import Facebook from './Facebook'
import axios from 'axios'

export default class Ads extends Facebook {
  constructor (user, parameters = null) {
    super(user)
    this.user = user
    this.parameters = parameters
  }
  getAdById () {
    return axios({
      method: 'GET',
      url: `/${this.parameters.adId}/adcreatives`,
      params: {
        access_token: this.user.token,
        fields: 'name,id,body,call_to_action_type,image_url,link_url,object_story_spec,status,title,url_tags'
      }
    })
      .then(res => res.data.data[0])
      .catch(err => {
        throw new Error(JSON.stringify(err))
      })
  }
  fetchAdInsignts () {
    // const Ad = this.SdkClass().Ad
    // let ad = new Ad(this.parameters.adId)
    // const fields = [
    //   'impressions', 'spend', 'adset_id', 'ad_id', 'ad_name', 'campaign_id', 'reach', 'cpm', 'cpc',
    //   'clicks', 'ctr'
    // ]
    // const params = {
    //   time_range: {
    //     since: this.parameters.startDate,
    //     until: this.parameters.endDate
    //   }
    // }
    // return new Promise(resolve => {
    //   resolve(ad.getInsights(fields, params))
    // })
    //   .then(res => {
    //     if (res[0]) {
    //       return res[0]._data
    //     } return {}
    //   })
    //   .catch(err => {
    //     throw new Error(JSON.stringify(err))
    //   })
    return new Promise(resolve => {
      resolve(true)
    })
  }
  createAd () {
    const account = this.connection().account
    const params = {
      access_token: this.user.token,
      status: 'PAUSED',
      name: this.parameters.name,
      adset_id: this.parameters.adsetId,
      promoted_object: {page_id: this.parameters.pageId},
      creative: {
        creative_id: this.parameters.adCreativeId
      },
      tracking_specs: [
        {'action.type': 'offsite_conversion', 'fb_pixel': this.parameters.pixelId}
      ]
    }
    return account.createAd([], params)
      .catch(err => {
        throw new Error(JSON.stringify(err))
      })
  }
}
